<ng-container
  *transloco="let t; read: 'calculator_result.charts.yearly-chart'">
  <psc-section-title
    [title]="t('title')"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>
  <div class="w-[100%] mb-10 flex justify-center">
    <canvas baseChart class="chart w-full limited-max-height"
            [data]="elEnergyChartData"
            [height]="resultChartsService.regularChartHeight"
            [options]="elEnergyChartOptions"
            [type]="elEnergyChartType"></canvas>
  </div>

  <div class="-ml-[5000px] absolute">
    <canvas baseChart class="chart limited-max-height"
            [width]="resultChartsService.chartWidth"
            [height]="resultChartsService.chartForPdfHeight"
            [data]="elEnergyChartData"
            [options]="elEnergyChartOptions"
            [type]="elEnergyChartType"></canvas>
  </div>
</ng-container>
